import React from 'react'
import { useFetchIncubation } from './api'
import { useAuthStore } from '../../../../store/authStore'
import IncubationForm from '.'
import DataPrefiller from './DataPrefiller'

const InitialView: React.FC = () => {
  const user = useAuthStore((state) => state.userData)
  console.log(user)
  const { data, isLoading, error } = useFetchIncubation()

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center h-64 space-y-4">
        <svg
          className="animate-spin h-10 w-10 text-blue-500"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          />
        </svg>
        <p className="text-gray-600">Loading...</p>
      </div>
    )
  }

  if (error) {
    return (
      <div className="text-center mt-8 text-red-500">Error loading data</div>
    )
  }

  return (
    <div className="flex flex-col items-center justify-center mt-10">
      {!user ? (
        <div className="flex flex-col items-center space-y-4">
          <svg
            className="animate-spin h-10 w-10 text-gray-500"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            />
          </svg>
          <p className="text-lg font-medium text-gray-700">Not Authenticated</p>
          <p className="text-sm text-gray-500">
            Please log in to view your applications
          </p>
        </div>
      ) : data?.data?.length ? (
        <DataPrefiller data={data.data[0]} />
      ) : (
        <IncubationForm />
      )}
    </div>
  )
}

export default InitialView
